import { Action, ActionReducer } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import * as AuthStoreActions from './auth-store.actions';
import { AuthStoreState } from './auth-store.model';

const initialState = new AuthStoreState();
export function reducer(
  state: AuthStoreState = initialState,
  incomingAction: Action,
): AuthStoreState {
  const action: AuthStoreActions.All = incomingAction as AuthStoreActions.All;
  switch (action.type) {
    case AuthStoreActions.TOKEN_LOADED: {
      const oktaClaims = cloneDeep(action.oktaClaims);
      Object.freeze(oktaClaims);
      return new AuthStoreState({ token: action.token, oktaClaims: action.oktaClaims });
    }
    case AuthStoreActions.LOGGED_OUT: {
      return initialState;
    }
  }
  return state;
}

export const authReducer: ActionReducer<AuthStoreState, Action> = reducer as ActionReducer<
  AuthStoreState,
  Action
>;
